<template>
  <v-img
    :height="imgHeight"
    :src="imgSource"
    gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
  >
    <v-layout column align-center justify-center fill-height mx-12 class="white--text">
      <h1
        class="white--text mb-2 mt-5 text-center font-weight-bold text-uppercase"
        v-bind:class="[activeClass]"
      >{{title}}</h1>
      <h1
        class="white--text mb-2 title"
        style="text-align: justify;"
        v-bind:class="[subtitleClass]"
      >{{subtitle}}</h1>
      <div
        class="justify-center align-center d-flex"
        :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']"
        v-if="header == ''"
      >
        <div class="animated">
          <v-btn
            class="mt-5 mx-3"
            :class="[btnClass]"
            :color="btnColor"
            :tile="btnTile"
            :rounded="btnRounded"
            :outlined="btnRounded"
            :dark="btnDark"
            x-large
            @click="dialog = !dialog;sendTagInscribete()"
          >INSCRÍBETE</v-btn>
        </div>
        <router-link to="/informes" style="text-decoration: none; padding-bottom: 10px;">
          <v-btn
            class="mt-5 mx-3"
            :class="[btnClass]"
            :color="btnColor"
            :tile="btnTile"
            :rounded="btnRounded"
            :outlined="btnRounded"
            :dark="btnDark"
            x-large
          >INFÓRMATE</v-btn>
        </router-link>
      </div>
      <div
        class="justify-center align-center d-flex"
        :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']"
        v-else-if="banner == ''"
      >
        <v-btn
          class="mt-5 mx-3"
          :class="[btnClass]"
          :color="btnColor"
          :tile="btnTile"
          :rounded="btnRounded"
          :outlined="btnRounded"
          :dark="btnDark"
          x-large
          @click="dialog = !dialog;sendTagInscribete()"
        >INSCRÍBETE</v-btn>
        <router-link to="/informes" style="text-decoration: none; padding-bottom: 10px;">
          <v-btn
            class="mt-5 mx-3"
            :class="[btnClass]"
            :color="btnColor"
            :tile="btnTile"
            :rounded="btnRounded"
            :outlined="btnRounded"
            :dark="btnDark"
            x-large
          >INFÓRMATE</v-btn>
        </router-link>
      </div>
      <div
        class="justify-center align-center d-flex"
        :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']"
        v-else-if="video == ''"
      >
        <v-btn
          class="mt-5 mx-3"
          :class="[btnClass]"
          :color="btnColor"
          :tile="btnTile"
          :rounded="btnRounded"
          :outlined="btnRounded"
          :dark="btnDark"
          x-large
          @click="dialogVideo = !dialogVideo"
        >
          Ver vídeo
          <v-icon right>mdi-play-circle</v-icon>
        </v-btn>
      </div>
      <v-dialog
        :max-width="$vuetify.breakpoint.mdAndUp ? '50vw' : '100vw'"
        tile
        v-model="dialogVideo"
      >
        <div style="text-align: right">
          <v-btn text dark icon @click="dialogVideo =  !dialogVideo">
            <i class="mdi mdi-close"></i>
          </v-btn>
        </div>

        <v-card>
          <iframe
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            src="https://www.youtube.com/embed/68fzLjCPzTs"
            style="height: 50vh;"
            frameborder="0"
            width="100%"
          ></iframe>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="800" :fullscreen="$vuetify.breakpoint.smAndDown" tile>
        <v-card :color="$vuetify.breakpoint.mdAndUp ? '#000000AA' : 'black'" class="px-5 py-5">
          <div class="d-flex justify-end">
            <v-btn
              style="position:absolute"
              class="text-end"
              icon
              large
              text
              @click="cerrarIncripcion()"
            >
              <v-icon color="white">mdi-close-circle</v-icon>
            </v-btn>
          </div>
          <v-form method="post" action="php/mail.php" id="nativeForm">
            <v-card-title class="white--text mb-2">
              <h1
                :class="[$vuetify.breakpoint.mdAndUp ? 'display-3' : 'display-1']"
                class="text-uppercase mb-4"
              >Recibe más información:</h1>
              <h3 class="title word-wrap">¡Nosotros nos pondremos en contacto contigo!</h3>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    color="white"
                    dark
                    label="NOMBRE (S)"
                    v-model="nombre_completo"
                    placeholder="Juan Perez"
                    type="text"
                    id="name_first"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    color="white"
                    dark
                    label="APELLIDOS"
                    v-model="apellidos_completos"
                    placeholder="López Sanchez"
                    type="text"
                    id="last_name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        readonly
                        v-on="on"
                        color="white"
                        dark
                        label="FECHA DE NACIMIENTO"
                        v-model="computedDateFormatted"
                        hint="DD/MM/YYYY"
                        placeholder="DD/MM/YYYY"
                        type="text"
                        id="birthday"
                        @click="datePicker = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      locale="es"
                      v-model="information.birthday"
                      @input="menu1 = false"
                      ref="picker"
                      :max="new Date().toISOString().substr(0, 10)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    color="white"
                    dark
                    label="NÚMERO TELEFÓNICO"
                    v-model="information.phone"
                    placeholder="(123)-123-1212"
                    v-mask="'(###)-###-####'"
                    type="phone"
                    id="phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    color="white"
                    dark
                    label="CORREO ELECTRÓNICO"
                    v-model="information.email"
                    placeholder="correo@ejemplo.com"
                    type="email"
                    id="email"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="d-flex pb-0" cols="12" sm="12" md="6">
                  <v-select
                    item-value="key"
                    :items="lic"
                    label="Licenciatura o diplomado de interés"
                    v-model="information.lic"
                    outlined
                    dark
                    color="white"
                  ></v-select>
                </v-col>
                <v-col class="d-flex pb-0" cols="12" sm="12" md="6">
                  <v-select
                    :items="states_2"
                    label="Estado"
                    v-model="information.state"
                    outlined
                    dark
                    color="white"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col class="py-0" cols="12" sm="12" md="12">
                  <v-checkbox
                    class="py-0"
                    v-model="information.information"
                    dark
                    label="Acepto recibir promociones y correos de UVA en Línea"
                  ></v-checkbox>
                </v-col>
                <v-col class="py-0" cols="6" sm="6" md="6">
                  <vue-recaptcha @expired="successRecaptcha = false" @verify="reCAPTCHAcallback()" sitekey="6Lc8XKkbAAAAAEl5syMFnnddk1gllGQIxJ8RE4vx" :loadRecaptchaScript="true"></vue-recaptcha>
                </v-col>                
              </v-row>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-layout
                :row="$vuetify.breakpoint.mdAndUp"
                :column="$vuetify.breakpoint.smAndDown"
                :reverse="$vuetify.breakpoint.smAndDown"
              >
                <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>
                <v-btn rounded text dark class="px-5" @click="cerrarIncripcion()">Cancelar</v-btn>
                <v-btn
                  rounded
                  color="primary"
                  class="px-5 mb-5"
                  :disabled="!successRecaptcha"
                  @click="validateNombre()"
                >Enviar formulario</v-btn>
              </v-layout>
            </v-card-actions>
          </v-form>
        </v-card>
        <!--<v-snackbar v-model="snackbar.visible" :multi-line="false" :right="true" :bottom="true">
          {{ snackbar.text }}
          <v-btn :color="snackbar.color" text @click="snackbar.visible = false">Cerrar</v-btn>
        </v-snackbar>-->
      </v-dialog>
      <v-dialog
        v-model="dialogInformes"
        max-width="80vw"
        :fullscreen="$vuetify.breakpoint.smAndDown"
      >
        <v-card color="white" class tile>
          <div class="d-flex justify-end">
            <v-btn
              style="position:absolute"
              class="text-end"
              icon
              large
              text
              @click="cerrarInformes()"
            >
              <v-icon color="black">mdi-close-circle</v-icon>
            </v-btn>
          </div>

          <v-layout
            :row="$vuetify.breakpoint.mdAndUp"
            class="mx-0"
            :column="$vuetify.breakpoint.smAndDown"
          >
            <v-flex
              xs12
              sm12
              md6
              style="background-position-x: center; background-size: cover;"
              :style="{backgroundImage: 'url('+`${publicPath}images/imagenes/pop-up-informes.jpg`+')'}"
              v-if="$vuetify.breakpoint.mdAndUp"
            ></v-flex>
            <v-flex xs12 sm12 md6 :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-2']">
              <v-card-title class="mb-12 d-flex flex-column justify-start align-start">
                <h1
                  :class="[$vuetify.breakpoint.lgAndUp ? 'display-3' : 'display-2']"
                  class="text-uppercase mb-4"
                  style="word-break: break-word;"
                >Obtén informes</h1>
                <h3 class="title word-wrap">¡Déjanos datos para establecer contacto contigo!</h3>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="PRIMER NOMBRE"
                      v-model="information.name_first"
                      placeholder="Juan"
                      type="text"
                      id="name_first"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="SEGUNDO NOMBRE"
                      v-model="information.name_second"
                      placeholder="Alejandro"
                      type="text"
                      id="name_second"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="APELLIDO PATERNO"
                      v-model="information.last_name"
                      placeholder="López"
                      type="text"
                      id="last_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="APELLIDO MATERNO"
                      v-model="information.mother_last_name"
                      placeholder="Garcia"
                      type="text"
                      id="mother_last_name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-on="on"
                          label="FECHA DE NACIMIENTO"
                          v-model="computedDateFormatted"
                          hint="DD/MM/YYYY"
                          placeholder="DD/MM/YYYY"
                          type="text"
                          id="birthday"
                          @click="datePicker = true"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es"
                        v-model="information.birthday"
                        @input="menu2 = false"
                        ref="picker"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="NÚMERO TELEFÓNICO"
                      placeholder="(123)-123-1212"
                      v-model="information.phone"
                      v-mask="'(###)-###-####'"
                      type="phone"
                      id="phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="CORREO ELECTRÓNICO"
                      v-model="information.email"
                      placeholder="correo@ejemplo.com"
                      type="email"
                      id="email"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Último grado cursado"
                      v-model="information.grade"
                      placeholder="Bachillerato"
                      type="grade"
                      id="grade"
                    ></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="ways"
                      label="¿Cómo te enteraste de nosotros?*"
                      hide-details
                      outlined
                      v-model="information.way"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="d-flex" cols="12" sm="12" md="6">
                    <v-select
                      :items="lic"
                      label="Licenciatura de interés"
                      outlined
                      v-model="information.lic"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" md="6">
                    <v-select :items="states" label="Estado" outlined v-model="information.state"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" md="6">
                    <v-text-field
                      v-show="information.state == 'OTRO ESTADO'"
                      label="Otro estado"
                      v-model="information.other_state"
                      type="text"
                      id="other_state"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-checkbox
                      v-model="information.information"
                      label="Acepto recibir promociones y correos de UVA en Línea"
                    ></v-checkbox>
                  </v-col>
                  <v-col class="py-0" cols="6" sm="6" md="6">
                    <vue-recaptcha @expired="successRecaptchaInfo = false" @verify="reCAPTCHAcallbackInfo()" sitekey="6Lc8XKkbAAAAAEl5syMFnnddk1gllGQIxJ8RE4vx" :loadRecaptchaScript="true"></vue-recaptcha>
                  </v-col>                  
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-layout
                  :row="$vuetify.breakpoint.mdAndUp"
                  :column="$vuetify.breakpoint.smAndDown"
                  :reverse="$vuetify.breakpoint.smAndDown"
                >
                  <div class="flex-grow-1" v-if="$vuetify.breakpoint.mdAndUp"></div>
                  <v-btn rounded text class="px-3" @click="cerrarInformes()">Cancelar</v-btn>
                  <v-btn
                    rounded
                    color="primary"
                    :disabled="!successRecaptchaInfo"
                    class="px-5 mb-5"
                    @click="submitInfo()"
                  >Enviar formulario</v-btn>
                </v-layout>
              </v-card-actions>
              <hr />
              <div class="text-center mt-5">
                <router-link style="text-decoration: none;" to="/faq">
                  <v-btn class="ma-2" rounded outlined color="primary">VER PREGUNTAS FRECUENTES</v-btn>
                </router-link>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :right="false">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Cerrar</v-btn>
        </v-snackbar>
      </v-dialog>
    </v-layout>
  </v-img>
</template>
<style lang="scss" scoped>
.bg-flex {
  background-size: cover !important;
}
.bg-flex-mobile {
  background-size: cover;
  height: 400px;
  margin-bottom: 1rem;
}
.word-wrap {
  word-break: break-word;
}
.custom-link {
  text-decoration: none;
  font-size: 2rem;
  color: #bdbdbd;
  height: 100px;
  width: 100px;
  margin: 1rem;
  &:hover {
    color: white;
    text-shadow: 1px 1px 6px rgba(255, 255, 255, 0.2);
    cursor: pointer;
  }
}
.div-position {
  position: absolute;
  bottom: 5%;
  right: 5%;
}
.div-position2 {
  position: absolute;
  bottom: 0%;
  right: 6.6%;
}
</style>
<style scoped>
.animated {
  -webkit-animation: pulse 0.5s infinite alternate;
  animation: pulse 0.5s infinite alternate;
}
@-webkit-keyframes pulse {
  to {
    -webkit-transform: scale(1.1);
  }
}
@keyframes pulse {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
<script>
import { mask } from "vue-the-mask";
import axios from "axios";
export default {
  directives: {
    mask
  },
  props: [
    "title",
    "subtitle",
    "header",
    "banner",
    "imgHeight",
    "activeClass",
    "subtitleClass",
    "imgSource",
    "btnTile",
    "btnRounded",
    "btnColor",
    "btnClass",
    "btnDark",
    "video"
  ],
  data() {
    return {
      successRecaptcha: false,       
      successRecaptchaInfo: false,      
      nombre_completo: "",
      apellidos_completos: "",
      nombres: [],
      apellidos: [],
      snackbar: false,
      snackbarColor: "",
      snackbarText: "",
      menu: false,
      modal: false,
      menu2: false,
      menu1: false,
      valid: false,
      dialogVideo: false,
      reference: "",
      publicPath: process.env.BASE_URL,
      information: {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        birthday: "",
        phone: "",
        email: "",
        lic: "",
        grade: "",
        state: "",
        other_state: "",
        way: "",
        information: false
      },
      ways:[
        "Redes sociales",
        "Recomendación",
        "Feria educativa",
        "Publicidad",
        "Folletos"
      ],
      dialogInformes: false,
      dialog: false,
      lic: [
        { key: "Administracion", text: "Lic. Admin. de empresas" },
        { key: "Educacion", text: "Lic. Ciencias de la educación" },
        { key: "Contaduria", text: "Lic. Contaduría" },
        { key: "Comercio", text: "Lic. Comercio internacional" },
        { key: "Derecho", text: "Lic. Derecho" },
        { key: "Personal", text: "Dip. Gestión Estratética Personal" },
        { key: "Logistica", text: "Dip. Gestión Logística para el Comercio Exterior" },
        { key: "Capital", text: "Dip. Gestión Estratégica de Capital Humano" },
      ],
      states: [
        { key: "AGS", text: "AGUASCALIENTES" },
        { key: "BC", text: "BAJA CALIFORNIA" },
        { key: "BCS", text: "BAJA CALIFORNIA SUR" },
        { key: "CHI", text: "CHIHUAHUA" },
        { key: "CHS", text: "CHIAPAS" },
        { key: "CMP", text: "CAMPECHE" },
        { key: "CMX", text: "CIUDAD DE MEXICO" },
        { key: "COA", text: "COAHUILA" },
        { key: "COL", text: "COLIMA" },
        { key: "DGO", text: "DURANGO" },
        { key: "GRO", text: "GUERRERO" },
        { key: "GTO", text: "GUANAJUATO" },
        { key: "HGO", text: "HIDALGO" },
        { key: "JAL", text: "JALISCO" },
        { key: "MCH", text: "MICHOACAN" },
        { key: "MEX", text: "ESTADO DE MEXICO" },
        { key: "MOR", text: "MORELOS" },
        { key: "NAY", text: "NAYARIT" },
        { key: "NL", text: "NUEVO LEON" },
        { key: "OAX", text: "OAXACA" },
        { key: "PUE", text: "PUEBLA" },
        { key: "QR", text: "QUINTANA ROO" },
        { key: "QRO", text: "QUERETARO" },
        { key: "SIN", text: "SINALOA" },
        { key: "SLP", text: "SAN LUIS POTOSI" },
        { key: "SON", text: "SONORA" },
        { key: "TAB", text: "TABASCO" },
        { key: "TLX", text: "TLAXCALA" },
        { key: "TMS", text: "TAMAULIPAS" },
        { key: "VER", text: "VERACRUZ" },
        { key: "YUC", text: "YUCATAN" },
        { key: "ZAC", text: "ZACATECAS" },
        { key: "OTRO", text: "OTRO..." }
      ],
      states_2: [
        { key: "AGS", text: "AGUASCALIENTES" },
        { key: "BC", text: "BAJA CALIFORNIA" },
        { key: "BCS", text: "BAJA CALIFORNIA SUR" },
        { key: "CHI", text: "CHIHUAHUA" },
        { key: "CHS", text: "CHIAPAS" },
        { key: "CMP", text: "CAMPECHE" },
        { key: "CMX", text: "CIUDAD DE MEXICO" },
        { key: "COA", text: "COAHUILA" },
        { key: "COL", text: "COLIMA" },
        { key: "DGO", text: "DURANGO" },
        { key: "GRO", text: "GUERRERO" },
        { key: "GTO", text: "GUANAJUATO" },
        { key: "HGO", text: "HIDALGO" },
        { key: "JAL", text: "JALISCO" },
        { key: "MCH", text: "MICHOACAN" },
        { key: "MEX", text: "ESTADO DE MEXICO" },
        { key: "MOR", text: "MORELOS" },
        { key: "NAY", text: "NAYARIT" },
        { key: "NL", text: "NUEVO LEON" },
        { key: "OAX", text: "OAXACA" },
        { key: "PUE", text: "PUEBLA" },
        { key: "QR", text: "QUINTANA ROO" },
        { key: "QRO", text: "QUERETARO" },
        { key: "SIN", text: "SINALOA" },
        { key: "SLP", text: "SAN LUIS POTOSI" },
        { key: "SON", text: "SONORA" },
        { key: "TAB", text: "TABASCO" },
        { key: "TLX", text: "TLAXCALA" },
        { key: "TMS", text: "TAMAULIPAS" },
        { key: "VER", text: "VERACRUZ" },
        { key: "YUC", text: "YUCATAN" },
        { key: "ZAC", text: "ZACATECAS" }
      ]
    };
  },
  watch: {
    menu1(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  computed: {
    referenceStore() {
      return this.$store.state.referenceStore;
    },
    computedDateFormatted () {
      return this.formatDate(this.information.birthday)
    },
  },
  methods: {
    reCAPTCHAcallback(){
        this.successRecaptcha = true;
    },    
    reCAPTCHAcallbackInfo(){
        this.successRecaptchaInfo = true;
    },    
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    sendTagInformes(){
      gtag("event", "conversion", {
        send_to: "AW-739642856/3J_xCKf-j8UBEOib2OAC",
        event_callback: () => {
          console.log("uvaonline-home-btn-informate");
        }
      });
    },
    sendTagInscribete(){
      gtag("event", "conversion", {
        send_to: "AW-739642856/QDl9CLaB_8QBEOib2OAC",
        event_callback: () => {
          console.log("uvaonline-home-btn-inscribete");
        }
      });
    },
    cerrarInformes() {
      this.clearFieldsInfo();
      this.dialogInformes = false;
    },
    cerrarIncripcion() {
      this.clearFieldsIns();
      this.dialog = false;
    },
    imageover() {
      this.isOnHover = true;
    },
    imageleave() {
      this.isOnHover = false;
    },
    makeReference() {
      var nombre = this.nombre_completo.replace(" ", "-");
      let state = this.information.state.substring(0, 3).toLowerCase();
      this.reference = nombre+state+this.information.lic.toLowerCase();
      this.$store.dispatch("setReference", this.reference);
      this.$store.dispatch("setEmail", this.information.email);
      this.$store.dispatch("setName", this.nombre_completo);
    },
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateDateInfo() {
      let today = new Date();
      let currentYear = parseInt(today.getFullYear());
      let date = this.information.birthday.split("/");
      let yy = parseInt(date[0]);
      if (currentYear - yy > 18) {
        this.dateValid = true;
      } else {
        this.dateValid = false;
        this.snackbarText = "Debes tener más de 18 años";

        this.snackbar = true;
      }
    },
    validateDateIns() {
      let today = new Date();
      let currentYear = parseInt(today.getFullYear());
      let date = this.information.birthday.split("/");
      let yy = parseInt(date[0]);
      if (currentYear - yy > 18) {
        this.dateValid = true;
      } else {
        this.dateValid = false;
        this.snackbarText = "Debes tener más de 18 años";

        this.snackbar = true;
      }
    },
    sendMailInfo() {
      fbq('track', 'CompleteRegistration');
      var self = this;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("last_grade", this.information.grade);
      formData.append("message", "Informacion");
      formData.append("subject", "Informes");
      formData.append("information_by_level", "Licenciatura");
      formData.append("carreer", this.information.lic);
      formData.append("municipality", this.information.state);
      formData.append("birthdate", this.information.birthday);
      formData.append("comunication", this.information.way);
      formData.append("webpage", "Uva en línea");
      axios({
        method: "post",
        url: "https://www.admin-uva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          }
        }
      })
        .then(function(response) {
          if (response.data.status == "200") {
            self.snackbarText =
              "Datos registrados, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.dialogInformes = !self.dialogInformes;
            self.clearFieldsInfo();
          } else {
            self.snackbarText =
              "Se ha producido un error, intentelo de nuevo mas tarde.";
            self.snackbarColor = "warning";
            self.snackbar = true;
          }
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    sendMailIns() {
      fbq('track', 'AddPaymentInfo');
      let url = this.publicPath + "php/mail.php";
      let self = this;
      this.makeReference();
      axios
        .post("https://www.admin-uva.tidingo.com/api/create-inscription", {
          name: this.nombre_completo,
          lastname: this.apellidos_completos,
          email: this.information.email,
          phone: this.information.phone,
          state: this.information.state,
          carrer: this.information.lic,
          birthday: this.information.birthday
        })
        .then(function(response) {
          if (response.status == 200) {
            self.dialog = !self.dialog;
            self.clearFieldsIns();
            self.reference = "";
            self.snackbarText =
              "Gracias por llenar el formulario, nosotros no pondremos en contacto contigo";
            self.the_color = "indigo";
            self.snackbar2 = true;
          }
        })
        .catch(function(error) {
          self.snackbarText = "Ocurrió un error, intentar más tarde";
          self.snackbar2 = true;
        });
    },
    validateFieldsInfo() {
      if (
        this.information.name_first != "" &&
        // this.information.name_second != "" &&
        this.information.last_name != "" &&
        this.information.way != "" &&
        this.information.grade != "" &&
        this.information.mother_last_name != "" &&
        this.information.birthday != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.lic != "" &&
        this.information.state != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar los campos";
        this.snackbar = true;
        this.snackbarColor = "red";
      }
    },
    validateFieldsIns() {
      if (
        this.nombre_completo != "" &&
        // this.information.name_second != "" &&
        //this.information.last_name != "" &&
        this.apellidos_completos != "" &&
        this.information.birthday != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.information.lic != "" &&
        this.information.state != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText = "Favor de completar los campos";
        this.snackbar = true;
        this.snackbarColor = "red";
      }
    },
    clearFieldsInfo() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        birthday: "",
        grade: "",
        phone: "",
        email: "",
        lic: "",
        state: "",
        other_state: "",
        information: false
      };
    },
    clearFieldsIns() {
      this.information = {
        birthday: "",
        phone: "",
        email: "",
        lic: "",
        state: "",
        other_state: "",
        information: false
      };
      this.apellidos_completos = "";
      this.nombre_completo = "";
    },
    validateNombre() {
      this.nombres = this.nombre_completo.split(" ");
      this.apellidos = this.apellidos_completos.split(" ");
      this.name_first = this.nombres[0];
      if (this.nombres[1] != null) {
        this.name_second = this.nombres[1];
      } else {
        this.name_second = "";
      }
      this.last_name = this.apellidos[0];
      this.mother_last_name = this.apellidos[1];
      this.submitIns();
    },
    submitIns() {
      this.validateFieldsIns();
      if (this.valid) {
        this.validateDateIns();
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.dateValid && this.emailValid && this.phoneValid) {
        this.makeReference();
        if(this.information.lic=='Personal' || this.information.lic=='Logistica' || this.information.lic=='Capital'){
          this.$router.push("/inscripcion_diplomado");
        }else{
          this.$router.push("/inscripcion");
        }
        this.sendMailIns();
      }
    },
    submitInfo() {
      this.validateFieldsInfo();
      if (this.valid) {
        this.validateDateInfo();
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.dateValid && this.emailValid && this.phoneValid) {
        this.sendMailInfo();
      }
    }
  }
};
</script>